import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const variantConditions = [
    { label: 'of all variants', value: 'AllVariants' },
    { label: 'of any variant', value: 'AnyVariant' },
    { label: 'of no variants', value: 'NoVariants' }
];

const quantityConditions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is greater than', value: 'GreaterThan' },
    { label: 'is greater than or equal to', value: 'GreaterThanOrEqual' },
    { label: 'is less than or equal to', value: 'LessThanOrEqual' },
    { label: 'is less than', value: 'LessThan' }
];

class ProductPriceFilterComponent extends React.Component {
    state = {};

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={variantConditions}
                    value={this.props.filter.variantCondition}
                    onChange={(selected) => this.onVariantConditionChange(selected)}
                />
                <Select
                    options={quantityConditions}
                    value={this.props.filter.priceCondition}
                    onChange={(selected) => this.onQuantityConditionChange(selected)}
                />
                <TextField
                    placeholder="Price"
                    type="number"
                    inputMode="decimal"
                    value={this.props.filter.price.toString()}
                    onChange={(newValue) => this.onPriceChange(newValue)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onVariantConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.variantCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onQuantityConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.priceCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onPriceChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.price = parseFloat(newValue);

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductPriceFilterComponent;
